export default "__VITE_ASSET__rzKQloOj__"